import createReducer from './createReducer';
import { FETCH_PERK_CODE_FAILURE, FETCH_PERK_SUCCESS, SET_SELECTED_PERK } from '../actions/perks';

const initialState = {
  selectedPerks: []
};
const handlers = {};

handlers[SET_SELECTED_PERK] = (state, { selectedPerk, perkCode }) => {
  const { selectedPerks } = state;
  selectedPerks.push({
    perkId: selectedPerk,
    perkCode
  });
  return ({
    ...state,
    selectedPerks,
    selectedPerk,
    error: null,
  });
};
handlers[FETCH_PERK_SUCCESS] = (state, { perkCode, perkId }) => {
  const { selectedPerks } = state;
  const filtered = selectedPerks.filter(({ perkId: id }) => id !== perkId);
  filtered.push({
    perkCode,
    perkId
  });
  return ({
    ...state,
    selectedPerks: filtered
  });
};
handlers[FETCH_PERK_CODE_FAILURE] = (state, { message }) => ({
  ...state,
  error: message,
});

export default createReducer(handlers, initialState);
